import { Component, Input } from '@angular/core';
import { LayoutService } from '../../../@core/utils';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout withScroll [class.header-main]="useHeader">
      <nb-layout-header fixed class="header-size" *ngIf="useHeader">
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" state="compacted" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="p-0">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {

  @Input('useHeader') public set useHeader(value: boolean) {
    this.layoutService.useHeader = value;
  }

  public get useHeader(): boolean {
    return this.layoutService.useHeader;
  }

  constructor(private layoutService: LayoutService) {
  }

}
